import data from './lists/Error_Correct_words_022223.json';

interface WordChoice {
  word: string;
  correction: string;
}
export default function words(): Array<WordChoice> {
  return data;
}
